import { toasts } from '@/utils/toasts';

/** DEV-2820 / DEV-2819 / DEV-2823 manager mutation toasts. */
export const managerMutationToasts = toasts.loadingToast;
